import update from 'immutability-helper';
import {LEO_THEME} from "../dev";
import eventApi from "../lib/api/event";
import {error} from "./eventReducer";
import fileApi from "../lib/api/file";
import {SET_NEW_SHOPPINGCART} from "./shoppingCartReducer";

export const initialState = {
    crossSellingEvent: null,
    metaData: {}
};

// ------------------------------------
// Constants
// ------------------------------------
export const SET_CROSS_SELLING_EVENT = 'CROSS_SELLING/SET_CROSS_SELLING_EVENT';
export const SET_CROSS_SELLING_EVENT_META_DATA = 'CROSS_SELLING/SET_CROSS_SELLING_EVENT_META_DATA';

export function setCrossSellingEvent(crossSellingEvent) {
    return {
        type: SET_CROSS_SELLING_EVENT,
        crossSellingEvent,
    };
}

export function setCrossSellingEventMetaData(metaData) {
    return {
        type: SET_CROSS_SELLING_EVENT_META_DATA,
        metaData,
    };
}

// -------------------
// Action Creators
// -------------------
export function checkIfCrossSellingEnabled() {
    return LEO_THEME.modules['cross-selling'] && LEO_THEME.modules['cross-selling']['event-uuid'];
}

export function loadCrossSellingEvent() {
    const crossSellingEnabled = checkIfCrossSellingEnabled()
    return (dispatch) => {
        if (!crossSellingEnabled) {
            return Promise.resolve();
        }
        const crossSellingEventUuid = LEO_THEME.modules['cross-selling']['event-uuid']
        return dispatch(fetchCrossSellingEventIfNeeded(crossSellingEventUuid))
    };
}

export function fetchCrossSellingEvent(uuid) {
    return async (dispatch, getState) => {
        try {
            const crossSellingEvent = await eventApi.getEvent(
                getState().merchant.merchantId,
                getState().merchant.themeName, uuid
            );
            dispatch(setCrossSellingEvent(crossSellingEvent));
            if (crossSellingEvent && crossSellingEvent.imagesMetadataIds && crossSellingEvent.imagesMetadataIds.length > 0) {
                dispatch(fetchMetaDataIfNeeded(crossSellingEvent.imagesMetadataIds[0]));
            }
        } catch (e) {
            console.info('could not load cross selling event', e.messageDe);
            if ((e.domainObject === 'Event') && (e.statusCode === 'FORBIDDEN')) {
                throw e;
            }
            dispatch(error(e.messageDe));
        }
    }
}

export function fetchCrossSellingEventIfNeeded(uuid) {
    return (dispatch, getState) => {
        if (!getState().crossSelling.crossSellingEvent) {
            return dispatch(fetchCrossSellingEvent(uuid));
        } else if (!(getState().crossSelling.crossSellingEvent.uuid === uuid)) {
            return dispatch(fetchCrossSellingEvent(uuid));
        }
        return Promise.resolve();
    };
}

export function fetchMetaData(id) {
    return async (dispatch) => {
        const metaData = await fileApi.getMetaData(id);
        if (metaData) {
            dispatch(setCrossSellingEventMetaData(metaData));
        }
    };
}

export function fetchMetaDataIfNeeded(id) {
    return (dispatch, getState) => {
        if (!getState().crossSelling.metaData[id]) {
            return dispatch(fetchMetaData(id));
        }
        return Promise.resolve();
    };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [SET_CROSS_SELLING_EVENT]: (state, action) => update(state, {
        crossSellingEvent: {$set: action.crossSellingEvent},
    }),
    [SET_CROSS_SELLING_EVENT_META_DATA]: (state, action) => update(state, {
        metaData: {
            [action.metaData.id]: {$set: action.metaData},
        },
    }),
    [SET_NEW_SHOPPINGCART]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducerFunction(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}
